import { InformationCircleIcon } from '@heroicons/react/24/solid'
import { ChangeEvent, ClipboardEvent, FC } from 'react'
import { Controller, useFormContext } from 'react-hook-form'

import { AppInput } from '@/components/shared/input'
import AppInputMaskedLocalized from '@/components/shared/input/ui/AppInputMaskedLocalized'

import { wrongNumberFormat } from '../../model/constants'
import { AcquiringFormData } from './model/schemas'

type Props = {
  isCommonPayment?: boolean
}

const AcquiringPayForm: FC<Props> = ({ isCommonPayment }) => {
  const {
    control,
    clearErrors,
    setError,
    formState: { errors }
  } = useFormContext<AcquiringFormData>()

  const handlePaste = (event: ClipboardEvent<HTMLInputElement>) => {
    const text = event.clipboardData.getData('text')
    if (!/\d/.test(text)) {
      setError('amount', { type: 'manual', message: wrongNumberFormat })
    }
  }

  return (
    <form>
      {!isCommonPayment && (
        <div className="my-32 sm:mb-16 sm:mt-20">
          <p className="mb-16 font-pro font-bold text-20 sm:text-16">
            Сумма платежа
          </p>

          <Controller
            name="amount"
            control={control}
            render={({ field }) => (
              <AppInputMaskedLocalized
                dataTestId="acquiring-payment-amount-input-id"
                value={field.value ? String(field.value) : ''}
                placeholder="Введите сумму"
                invalid={Boolean(errors.amount?.message)}
                invalidMessage={errors.amount?.message}
                onChange={(event: ChangeEvent) => {
                  clearErrors('amount')
                  field.onChange(event)
                }}
                onPaste={handlePaste}
                className="mb-4 mt-8 !h-56 !w-[320px] border border-grey-20 sm:!h-48 sm:!w-full"
              />
            )}
          />
          {!errors.amount?.message && (
            <div className="flex gap-4 text-grey-70">
              <InformationCircleIcon className="h-20 w-20" /> Не более 1 000 000
              ₽
            </div>
          )}
        </div>
      )}

      <div className="my-32 sm:mb-16 sm:mt-20">
        <p className="mb-16 font-pro font-bold text-20 sm:text-16">
          Email для отправки фискального чека
        </p>

        <Controller
          name="email"
          control={control}
          render={({ field }) => (
            <AppInput
              {...field}
              dataTestId="acquiring-payment-email-input-id"
              placeholder="Email"
              invalid={Boolean(errors.email?.message)}
              invalidMessage={errors.email?.message}
              className="!h-56 !w-[320px] border border-grey-20 sm:!h-48 sm:!w-full"
            />
          )}
        />
      </div>
    </form>
  )
}

export default AcquiringPayForm
